import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { ToggleSwitch } from '../../../components/common/inputs/ToggleSwitch';
import { useLayout } from '../../../hooks/screen/useLayout';
import { useGetUserProfile } from '../../../hooks/user/useGetUserProfile';
import { formatDate } from '../../../utils/formatter/formatDate.util';
import { useNotification } from '../../../provider/ToastNotificationProvider';
import { useAdvertisementConsent } from '../../../hooks/user/useAdvertisementConsent';
import ReactGA from 'react-ga4';

export const MyInfoAlarmSettingPage = () => {
  const { userProfile } = useGetUserProfile();
  const { openNotification } = useNotification();
  const updateAdConsent = useAdvertisementConsent('MY');

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} headerTitle={'알람 설정'} />,
    fixedHeaderHeight: 48,
  });

  const changeAdvertisementTermsAgreement = ({ isTurnOn }: { isTurnOn: boolean }) => {
    updateAdConsent({
      isAgreeing: isTurnOn,
      onSuccess: () => {
        const resultText = isTurnOn ? '처리' : '철회';
        const message = `광고성 정보 수신 ${resultText} 요청이\n정상적으로 처리되었습니다.\n(${formatDate(
          new Date().toString(),
        )})`;
        openNotification({
          message,
        });
      },
    });
  };

  const handleAdvertisementTermsAgreementClick = () => {
    if (userProfile?.advertisementTermsAgreement) {
      changeAdvertisementTermsAgreement({ isTurnOn: false });
    } else {
      changeAdvertisementTermsAgreement({ isTurnOn: true });
    }
  };

  if (userProfile) {
    return (
      <Container>
        <AlarmSettingsSection>
          <Box>
            <Title>{'광고성 정보 수신 동의'}</Title>

            <ToggleSwitch
              isChecked={userProfile?.advertisementTermsAgreement ?? false}
              onClick={handleAdvertisementTermsAgreementClick}
            />
          </Box>
        </AlarmSettingsSection>
      </Container>
    );
  }

  return <></>;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`;

const AlarmSettingsSection = styled.div`
  display: flex;
  padding: var(--radius-large, 16px) var(--radius-large, 16px) 32px var(--radius-large, 16px);
  flex-direction: column;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;
`;

const Title = styled.div`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 13.6px */
`;
